/**
 * Which permission set a route guard checks against.
 *
 * `hasAnyPermission` uses campaign permissions exclusively whenever it gets any, so a page that is
 * not campaign-scoped has to pass `null`: the campaign in context is left over from wherever the
 * user was before, and a client user's shared-access campaign carries none of their account-level
 * permissions (those groups are not suffixed " - Shared").
 */
export const effectiveCampaignPermissions = (
  campaignScoped: boolean | undefined,
  campaignPermissions: string[] | undefined,
  contextCampaignPermissions: string[] | undefined,
): string[] | null | undefined =>
  campaignScoped === false ? null : (campaignPermissions ?? contextCampaignPermissions);
